import React from "react";

/* Clarity brand mark — uses the actual PNG asset shipped at /clarity-logo.png.
   Scales by height; width auto-computes to preserve aspect ratio. */
export const ClarityWordmark = ({
  height = 56,
  className = "",
  style = {},
  ...rest
}) => (
  <img
    src="/clarity-logo.png"
    alt="Clarity by 589 Labs — AI Powered Solutions"
    className={`block ${className}`}
    style={{ height: `${height}px`, width: "auto", display: "block", ...style }}
    data-testid="clarity-wordmark"
    {...rest}
  />
);

export default ClarityWordmark;
